export default __webpack_public_path__ + "static/media/UAW.71193cde.png";